import * as React from 'react';
import Header from '../../component/Header/Header';
import Display from '../Main/DisplaySlider/DisplaySlider';
import BodyOne from './BodyOne/BodyOne';
import BodyTwo from './BodyTwo/BodyTwo';
import BodyThree from './BodyThree/BodyThree';
import Messenger from '../../component/Messenger/Messanger';

export interface IMain {
  match: any;
}

export default function Main(props: IMain) {
  const { match } = props;
  let len = match.url.length;
  match.url =
    match.url[len - 1] === '/' ? match.url.substring(0, len - 1) : match.url;

  return (
    <div className=' min-wth '>
      <Header />
      <main>
        <Display />
        <BodyOne />
        <BodyTwo />
        <BodyThree match={match.url} />
        <Messenger />
      </main>
    </div>
  );
}
